import { Button, type ButtonProps } from "@chakra-ui/react";

function PrimaryButton({ children, ...props }: ButtonProps) {
	return (
		<Button
			bg="brand.600"
			color="white"
			variant="solid"
			w={props.w ?? "100%"}
			mt={props.mt}
			disabled={props.disabled}
			type={props.type}
			onClick={props.onClick}
			isDisabled={props.isDisabled}
			cursor={props.isDisabled ? "not-allowed" : "pointer"}
			opacity={props.isDisabled ? 0.5 : 1}
		>
			{children}
		</Button>
	);
}

export default PrimaryButton;
